import shouldForwardProp from "@styled-system/should-forward-prop";

import {
  background,
  color,
  compose,
  cursorProp,
  EmotionComponent,
  layout,
  position,
  space,
  styled,
  textTransformProp,
  themeGet,
  typography,
  visibilityProp,
} from "@catchoftheday/theme";

import { ButtonProps } from "./types";

export const textButtonProps = compose(
  visibilityProp,
  cursorProp,
  space,
  layout,
  background,
  position,
  color,
  typography,
  textTransformProp
);

export const TextButton: EmotionComponent<ButtonProps> = styled("button", {
  shouldForwardProp,
})`
  border: none;
  padding: 0;
  background: transparent;
  color: ${themeGet("colors.secondary")};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  ${textButtonProps}
`;

TextButton.displayName = "TextButton";

export default TextButton;
